import React, { useEffect, useState } from 'react';
import './ParallaxEffects.css';

// Floating geometric background shapes
export const FloatingShapes = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY * 0.05);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="floating-elements">
      <div 
        className="floating-shape circle shape-1"
        style={{ transform: `translateY(${scrollY * 0.3}px)` }}
      />
      <div 
        className="floating-shape square shape-2"
        style={{ transform: `translateY(${-scrollY * 0.5}px) rotate(45deg)` }}
      />
      <div 
        className="floating-shape square shape-3"
        style={{ transform: `translateY(${scrollY * 0.4}px) rotate(45deg)` }}
      />
      <div 
        className="floating-shape line shape-4"
        style={{ transform: `translateX(${scrollY * 0.2}px)` }}
      />
      <div 
        className="floating-shape circle shape-5"
        style={{ transform: `translateY(${-scrollY * 0.35}px)` }}
      />
    </div>
  );
};

// Scroll progress indicator at top of page
export const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const currentProgress = (window.scrollY / totalHeight) * 100;
      setProgress(currentProgress);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div 
      className="scroll-progress"
      style={{ transform: `scaleX(${progress / 100})` }}
    />
  );
};

// Parallax background for sections
export const ParallaxBackground = ({ children, imageUrl, speed = 0.3, overlay = true }) => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setOffset(window.scrollY * speed);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [speed]);

  return (
    <div className="relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ 
          backgroundImage: `url(${imageUrl})`,
          transform: `translateY(${offset}px) scale(1.1)`,
          transition: 'transform 0.1s ease-out'
        }}
      />
      {overlay && (
        <div className="absolute inset-0 bg-white/80" />
      )}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};
